
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/match-booster/quick-start",
      function () {
        return require("private-next-pages/match-booster/quick-start.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/match-booster/quick-start"])
      });
    }
  